import React, { useEffect } from 'react';
import YouTube from 'react-youtube';
import fetch from 'utilities/fetch';
import { bugsnagNotify } from 'utilities/bugsnag';
import { paths } from 'config/path_helpers';
import style from './style.module.scss';

interface YouTubeVideoPlayerProps {
  videoFileId: number;
  youTubeVideoId: string;
}

export const YouTubeVideoPlayer: React.FC<YouTubeVideoPlayerProps> = (props) => {
  const { videoFileId, youTubeVideoId } = props;
  let lastStartPosition = 0;
  let curPosition = 0;
  let player = null;

  // If a user clicks on a phrase in the transcript, jump to that point in the video
  useEffect(() => {
    document.addEventListener('phraseClicked', (e: CustomEvent) => {
      if (player) {
        player.seekTo(e.detail.time);
      }
    });
  }, []);

  const logStop = () => {
    if (curPosition - lastStartPosition > 0.1) {
      fetch(paths.api.videoViews(videoFileId), {
        method: 'POST',
        body: JSON.stringify({
          view: {
            start: lastStartPosition,
            stop: curPosition
          }
        })
      }).catch((error) => {
        bugsnagNotify(error);
      });
    }
  };

  // Called when video is paused, video ends, or the user manually moves their position
  const onPlayerChange = (e) => {
    curPosition = e.target.getCurrentTime();
    logStop();
    lastStartPosition = curPosition;
  };

  const setPlayer = (e) => {
    player = e.target;
  };

  return (
    <div className={style.youTubeWrapper}>
      <YouTube
        videoId={youTubeVideoId}
        opts={{ width: '100%', height: '100%' }}
        onReady={(e) => setPlayer(e)}
        onStateChange={(e) => onPlayerChange(e)}
      />
    </div>
  );
};

export default YouTubeVideoPlayer;
